import { createRouteLoader, WrapRouteComponent, RouteErrorComponent } from '@ice/runtime';
import type { CreateRoutes } from '@ice/runtime';
const createRoutes: CreateRoutes = ({
  requestContext,
  renderMode,
}) => ([
  {
    path: 'perms/group/SchemaFormRenderer',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-group-schemaformrenderer" */ '@/pages/perms/group/SchemaFormRenderer');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/group/SchemaFormRenderer',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/group/SchemaFormRenderer',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-group-schemaformrenderer',
    index: undefined,
    id: 'perms/group/SchemaFormRenderer',
    exact: true,
    exports: ["SchemaFormRenderer","default"],
  },{
    path: 'perms/group/useGroupData',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-group-usegroupdata" */ '@/pages/perms/group/useGroupData');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/group/useGroupData',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/group/useGroupData',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-group-usegroupdata',
    index: undefined,
    id: 'perms/group/useGroupData',
    exact: true,
    exports: ["useGroupData"],
  },{
    path: 'perms/group/formSchema',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-group-formschema" */ '@/pages/perms/group/formSchema');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/group/formSchema',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/group/formSchema',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-group-formschema',
    index: undefined,
    id: 'perms/group/formSchema',
    exact: true,
    exports: ["buildFormValuesFromResponse","buildPayloadFromFormValues","businessLinesConfig","formSchemaConfig"],
  },{
    path: 'perms/role/useRoleData',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-role-useroledata" */ '@/pages/perms/role/useRoleData');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/role/useRoleData',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/role/useRoleData',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-role-useroledata',
    index: undefined,
    id: 'perms/role/useRoleData',
    exact: true,
    exports: ["useRoleData"],
  },{
    path: 'perms/user/useUserData',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-user-useuserdata" */ '@/pages/perms/user/useUserData');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/user/useUserData',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/user/useUserData',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-user-useuserdata',
    index: undefined,
    id: 'perms/user/useUserData',
    exact: true,
    exports: ["useUserData"],
  },{
    path: 'perms/group/interface',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-group-interface" */ '@/pages/perms/group/interface');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/group/interface',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/group/interface',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-group-interface',
    index: undefined,
    id: 'perms/group/interface',
    exact: true,
    exports: [],
  },{
    path: 'perms/role/interface',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-role-interface" */ '@/pages/perms/role/interface');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/role/interface',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/role/interface',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-role-interface',
    index: undefined,
    id: 'perms/role/interface',
    exact: true,
    exports: [],
  },{
    path: 'perms/user/interface',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-user-interface" */ '@/pages/perms/user/interface');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/user/interface',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/user/interface',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-user-interface',
    index: undefined,
    id: 'perms/user/interface',
    exact: true,
    exports: [],
  },{
    path: 'login-success',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-success-index" */ '@/pages/login-success/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login-success',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login-success',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'login-success-index',
    index: true,
    id: 'login-success',
    exact: true,
    exports: ["default"],
  },{
    path: 'perms/group',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-group-index" */ '@/pages/perms/group/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/group',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/group',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-group-index',
    index: true,
    id: 'perms/group',
    exact: true,
    exports: ["default"],
  },{
    path: 'perms/role',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-role-index" */ '@/pages/perms/role/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/role',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/role',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-role-index',
    index: true,
    id: 'perms/role',
    exact: true,
    exports: ["default"],
  },{
    path: 'perms/user',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-user-index" */ '@/pages/perms/user/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms/user',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms/user',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-user-index',
    index: true,
    id: 'perms/user',
    exact: true,
    exports: ["default"],
  },{
    path: 'exception/403',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_exception-403" */ '@/pages/exception/403');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'exception/403',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'exception/403',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'exception-403',
    index: undefined,
    id: 'exception/403',
    exact: true,
    exports: ["default"],
  },{
    path: 'exception/404',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_exception-404" */ '@/pages/exception/404');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'exception/404',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'exception/404',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'exception-404',
    index: undefined,
    id: 'exception/404',
    exact: true,
    exports: ["default"],
  },{
    path: 'login',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'login-index',
    index: true,
    id: 'login',
    exact: true,
    exports: ["default"],
  },{
    path: 'perms',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_perms-index" */ '@/pages/perms/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: 'perms',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: 'perms',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'perms-index',
    index: true,
    id: 'perms',
    exact: true,
    exports: ["default"],
  },{
    path: '',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: true,
    id: '/',
    exact: true,
    exports: ["default"],
  },{
    path: '*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_$" */ '@/pages/$');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: '$',
    index: undefined,
    id: '*',
    exact: true,
    exports: ["default"],
  },{
    path: '/login',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_login-index" */ '@/pages/login/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/login',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/login',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'login-index',
    index: undefined,
    id: '/login',
    exact: true,
    exports: ["default"],
  },{
    path: '/taxi/*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/taxi/*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/taxi/*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: undefined,
    id: '/taxi/*',
    exact: true,
    exports: ["default"],
  },{
    path: '/dlv/*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/dlv/*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/dlv/*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: undefined,
    id: '/dlv/*',
    exact: true,
    exports: ["default"],
  },{
    path: '/perms/*',
    async lazy() {
      const componentModule = await import(/* webpackChunkName: "p_index" */ '@/pages/index');
      return {
        ...componentModule,
        Component: () => WrapRouteComponent({
          routeId: '/perms/*',
          isLayout: false,
          routeExports: componentModule,
        }),
        loader: createRouteLoader({
          routeId: '/perms/*',
          requestContext,
          renderMode,
          module: componentModule,
        }),
      };
    },
    errorElement: <RouteErrorComponent />,
    componentName: 'index',
    index: undefined,
    id: '/perms/*',
    exact: true,
    exports: ["default"],
  },
]);
export default createRoutes;
